import type { HaneyPoint } from "../lib/haney";

// The authoritative store is the database. The react-query hooks read and write the
// server and fall back to these helpers when that read fails, so an import is not lost.
// Not a reactive store — react-query owns that.
const KEY = (fieldId: string) => `sm_haney:${fieldId}`;

export function loadLocalHaney(fieldId: string): HaneyPoint[] {
  try {
    const raw = localStorage.getItem(KEY(fieldId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveLocalHaney(fieldId: string, points: HaneyPoint[]): void {
  try {
    localStorage.setItem(KEY(fieldId), JSON.stringify(points));
  } catch {
    /* quota / disabled storage — server is the real store; nothing to do */
  }
}
